/** Date and time in the UI language, for example `18/10/2026, 10:00:00`. */
export function formatDateTime(iso: string, locale?: string): string {
  return new Date(iso).toLocaleString(locale);
}

/** Date only in the UI language, for example `Jul 18, 2012` or `18.07.2012`. */
export function formatDate(iso: string, locale?: string): string {
  return new Date(iso).toLocaleDateString(locale, { dateStyle: 'medium' });
}
